import React from 'react';
const SvgPause: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16 18v0a1.5 1.5 0 01-1.5-1.5v-9A1.5 1.5 0 0116 6v0a1.5 1.5 0 011.5 1.5v9A1.5 1.5 0 0116 18zM8 18v0a1.5 1.5 0 01-1.5-1.5v-9A1.5 1.5 0 018 6v0a1.5 1.5 0 011.5 1.5v9A1.5 1.5 0 018 18z"
      />
    </svg>
  );
};
export default SvgPause;
